import React, { useEffect, useState } from 'react';

import { Container, Row, Col, Card } from 'reactstrap';

import { useHistory } from 'react-router-dom';

import axios from 'axios';

import { 
  PRODUCTS_LIST, END_USERS_LIST, USERS_LIST, 
  STORES_LIST, DASHBOARD_LIST, 
} from '../../config/config.js';
import Charts from '../Chart/Chart';
import './home.css';

const Home = () => {
  const history = useHistory();

  const [users, setUsers] = useState('');
  const [orders, setOrdrs] = useState('');
  const [admins, setAdmins] = useState('');
  const [managers, setMngrs] = useState('');
  const [revenue, setRevenue] = useState('');

  const [pview, setPView] = useState(true);
  const [sview, setSView] = useState(true);
  const [aview, setAView] = useState(true);
  const [eview, setEView] = useState(true);
  const [cview, setCView] = useState(true);
  const [oview, setOView] = useState(true);

  const getProducts = () => {
    // Products  
    axios({
      method: 'get',
      url: PRODUCTS_LIST
    }).then((res) => {
      setOrdrs(res.data.total_count);
    }).catch((err) => {
      console.log(err);
    });
  };

  const getEndUsers = () => {
    // Customers
    axios({
      method: 'get',
      url: END_USERS_LIST
    })
    .then((res) => {
      setUsers(res.data.total_count);
    }).catch((err) => {
      console.log(err);
    });
  };

  const getAdmins = () => {
    // Admins
    axios({
      method: 'get',
      url: USERS_LIST
    })
    .then((res) => {
      setAdmins(res.data.total_count);
    })
    .catch( (err) => {
      console.log(err);
    });
  };

  const getStores = () => {
    // Store Managers
    axios({
      method: 'get',
      url: STORES_LIST
    })
    .then((res) => {
      setMngrs(res.data.total_count);
    })
    .catch( (err) => {
      console.log(err);
    });
  };

  const getRevenue = () => {
    // Total Revenue
    axios({
      method: 'get',
      url: DASHBOARD_LIST,
    }).then((res) => {
      if(res.data.TOTAL_REVENUE_GENERATED.TOTAL_REVENUE_GENERATED!==null){
        setRevenue(res.data.TOTAL_REVENUE_GENERATED.TOTAL_REVENUE_GENERATED);
      }else{
        setRevenue(0);
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  useEffect(() => {
    // const socket = io({GLOBAL_DOMAIN}, { transports: ["websocket"] });
    // socket.connect();
    // console.log('Logger: ', socket, window.location.protocol, window.location.protocol === 'https:' ? 'wss' : 'ws');

    // socket.on('connect_error', (error) => {
      // console.log('error while connection with socket: ', error.message);
      // socket.emit('message', {message:'Welcome to atumlife'});
      // socket.on('message', {message:'Welcome to atumlife'});    
    // });

    getAdmins(); getEndUsers(); 
    getStores(); getRevenue();
    getProducts(); 
  }, []);

  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem('roleJson'));
    let obj = Object.keys(list.menu);

    for(let i=0; i<obj.length; i++){
      if(obj[i]==='adminusers'){
        setAView(list.menu[obj[i]].enabled);
      }else if(obj[i]==='endusers'){
        setEView(list.menu[obj[i]].enabled);
      }else if(obj[i]==='orders'){
        setOView(list.menu[obj[i]].enabled);
      }else if(obj[i]==='products'){
        setPView(list.menu[obj[i]].enabled);
      }else if(obj[i]==='categories'){
        setCView(list.menu[obj[i]].enabled);
      }else if(obj[i]==='stores'){
        setSView(list.menu[obj[i]].enabled);
      }
    };
  }, []);

  return (
    <div>
      <Container className='mt-4'>
        <Row style={{padding: '2px'}}>
          <Col xs={12} md={12}>
            <Row>
              {aview===true && <Col xs={12} md={2}>
                <Card className='admin-users_card mt-1' style={{ width: '100%', height: '13vh'}}>
                  <div onClick={() => history.replace('/users')} style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', cursor: 'pointer'}}>
                    <div style={{fontSize: '15px', fontWeight: '600'}}>
                      Admin Users
                    </div>
                    <div style={{fontSize: '18px', fontWeight: '700', textAlign: 'center'}}>
                      {admins}
                    </div>
                  </div>
                </Card>
              </Col>}

              {sview===true && <Col xs={12} md={2}>
                <Card className='store-managers_card mt-1' style={{ width: '100%', height: '13vh'}}>
                  <div onClick={() => history.replace('/stores')} style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', cursor: 'pointer'}}>
                    <div style={{fontSize: '15px', fontWeight: '600'}}>
                      Store
                    </div>
                    <div style={{fontSize: '18px', fontWeight: '800', textAlign: 'center'}}>
                      {managers}
                    </div>
                  </div>
                </Card>
              </Col>}

              {eview===true && <Col xs={12} md={2}>
                <Card className='end-users_card mt-1' style={{ width: '100%', height: '13vh'}}>
                  <div onClick={() => history.replace('/endusers')} style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', cursor: 'pointer'}}>
                    <div style={{fontSize: '15px', fontWeight: '600'}}>
                      End Users
                    </div>
                    <div style={{fontSize: '18px', fontWeight: '800', textAlign: 'center'}}>
                      {users}
                    </div>
                  </div>
                </Card>
              </Col>}

              {pview && <Col xs={12} md={2}>
                <Card className='products_card mt-1' style={{ width: '100%', height: '13vh'}}>
                  <div onClick={() => history.replace('/products')} style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', cursor: 'pointer'}}>
                    <div style={{fontSize: '15px', fontWeight: '600'}}>
                      Products
                    </div>
                    <div style={{fontSize: '18px', fontWeight: '800', textAlign: 'center'}}>
                      {orders}
                    </div>
                  </div>
                </Card>
              </Col>}

              <Col xs={12} md={2}>
                <Card className='total-revenue_card mt-1' style={{ width: '100%', height: '13vh'}}>
                  <div style={{display: 'flex', flexDirection: 'column', cursor: 'default', margin: '0px', padding: '9px'}}>
                    <div style={{fontSize: '15px', fontWeight: '600'}}>
                      Total Revenue
                    </div>
                    <div style={{fontSize: '18px', fontWeight: '800'}}>
                      {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(revenue)}
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>

          <Col xs={12} md={12} style={{ marginTop: '5vh' , width: '100%' }}>
            <Charts cat={cview} ords={oview}  />
          </Col>
        </Row>
      </Container>
    </div>
  )
};

export default Home;